/**
 * Former standalone CRM URLs and their consolidated hub locations. App routes
 * redirect each one (preserving sub-paths, query strings and hashes); the table
 * is mirrored in docs/route-redirects.md.
 */
export const RETIRED_CRM_ROUTES: ReadonlyArray<{ from: string; to: string }> = [
  { from: '/partner-engagement/insights', to: '/insights/lifecycle' },
  { from: '/partner-engagement/forecast', to: '/insights/forecast' },
  { from: '/partner-engagement/renewals', to: '/insights/renewals' },
  { from: '/partner-engagement/retention', to: '/insights/retention' },
  { from: '/partner-engagement/data-quality', to: '/insights/data-quality' },
  { from: '/partner-engagement/reviews', to: '/insights/reviews' },
  { from: '/partner-engagement/cases', to: '/insights/cases' },
  { from: '/partner-engagement/delivery', to: '/insights/delivery' },
  { from: '/partner-engagement/agreements', to: '/insights/agreements' },
  { from: '/partner-engagement/discovery', to: '/insights/discovery' },
  { from: '/partner-engagement/stakeholders', to: '/insights/stakeholders' },
  { from: '/partner-engagement/activities', to: '/connect/activities' },
  { from: '/partner-engagement/social-leads', to: '/connect/social-leads' },
  { from: '/partner-engagement/referrals', to: '/connect/referrals' }
];

/** Maps a former standalone CRM path to its new home, or returns it unchanged. */
export function consolidatedPath(path: string): string {
  const match = RETIRED_CRM_ROUTES.find(route => path === route.from || path.startsWith(route.from + '/') || path.startsWith(route.from + '?'));
  return match ? match.to + path.slice(match.from.length) : path;
}
